<template>
  <div class="change_buttons">
    <div class="flex price_block" v-for="project in $AllProjects" v-if="[1,3,5].includes(project.id)">
      <span class="mr-1 project_title"><strong>{{ project.title }}</strong></span>
      <div v-for="(price, index) in getPrices(drug.prices, project.id)">
                      <span v-if="index < 2" class="price_span">{{ price.qty }}: <strong>{{
                          +price.price * +drug.pack_set
                        }}</strong> ({{ getProfitPercent(drug, price.price) }}%)</span>
        <span v-else class="price_span">{{ price.qty }} ...</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['drug', 'invoices', 'profitCalculation'],
  data() {
    return {}
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects']
    },
  },
  methods: {
    getPrices(prices, projectId) {
      let arr = prices.filter((p) => p.site_id === projectId);
      if (arr) {
        arr = _.orderBy(arr, 'qty')
      }
      return arr;
    },
    getProfitPercent(record, price) {
      let costPrice = +(this.invoices?.[0]?.cost_price ?? record.projected_price ?? 0) * +(this.profitCalculation && this.profitCalculation.calculatedRate || 0);
      costPrice *= +record.pack_set;
      const setPrice = +price - (+price * +(this.profitCalculation && this.profitCalculation.deliveryPercent || 0) / (100 + (this.profitCalculation && this.profitCalculation.deliveryPercent || 0))) - +(this.profitCalculation && this.profitCalculation.delivery || 0);
      return Math.round(setPrice * 100 / costPrice) - 100;
    },
  }
}
</script>

<style scoped>
.change_buttons .btn {
  pointer-events: none;
  padding: 1px 4px !important;
  font-size: 12px;
  margin-bottom: 2px;
  cursor: pointer;
}

.change_buttons div {
  margin-right: 3px;
}

.change_buttons label {
  vertical-align: sub;
}

.price_block {
  font-size: 15px;
  margin-bottom: 15px;
}

.price_block .project_title {
  width: 35px;
}

.price_span {
  margin-right: 3px;
  border: 1px solid lightgray;
  padding: 3px;
}
</style>
